// import React from "react";
// import { DataGrid } from "@mui/x-data-grid";


// const DataGridDemo = ({ columns, rows, loading, error }) => {
//   if (loading) return <div>Loading...</div>;
//   //  if (error) return <div>Error: {error}</div>;

//   return (
//     <div style={{ height: 400, width: "100%" }}>
//       <DataGrid
//         rows={rows}
//         columns={columns}
//         // getRowId={(row) => row.class_id}
//         localeText={{
//           toolbarDensity: "Size",
//           toolbarDensityLabel: "Size",
//           toolbarDensityCompact: "Small",
//           toolbarDensityStandard: "Medium",
//           toolbarDensityComfortable: "Large",
//         }}
        
//       />
//     </div>
//   );
// };

// export default DataGridDemo;


import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
// import './DataGridDemo.css'; // Optional: Custom styles for DataGrid

const DataGridDemo = ({ columns, rows, loading, onRowClick }) => {
  return (
    <div style={{ height: 400, width: '100%' }}>
      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
          // onRowClick={(params) => onRowClick(params.row)}
        />
      )}
    </div>
  );
};

DataGridDemo.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func.isRequired,
};

DataGridDemo.defaultProps = {
  loading: false,
};

export default DataGridDemo;
